import { SecurityMeasureModel } from "../../common/components/dotLegalSecurityMeasure/DotLegalSecurityMeasure.types";
import { SelectableProcessingActivityItem } from "../../processingActivity/ProcessingActivity.types";

export enum SystemStorageType {
    OnPremise = 1,
    Cloud = 2,
    Hybrid = 3,
}

export enum SystemEntityType {
    Application = 1,
    SaaS = 2,
    Sensor = 3,
    OperatingSystem = 4,
    Other = 5,
    OperationalTechnology = 6,
    Endpoints = 7,
    ITInfrastructure = 8,
}

export enum SystemDataType {
    PersonalData = 1,
    BusinessData = 2,
}

export interface SystemPersonalDataViewModel {
    dataCategories: Array<SystemDataCategories>;
    systemDataSubjects: Array<string>;
    processingActivityDataSubjects: Array<string>;
}

export interface SystemDataCategories {
    dataCategoryId: string;
    isSystemSelected: boolean;
    processingActivities: Array<SelectableProcessingActivityItem>;
    processingActivitiesWithoutAccess: number | null;
}

export interface CustomFieldValue {
    customInputFieldId: string;
    value: any;
}

export enum DistributionArea {
    GlobalSystem = 0,
    LocalSystem = 1,
    PhysicalArchive = 2,
}

export enum SystemStatus {
    Active = 1,
    UnderImplementation = 2,
    PhasedOut = 3,
    UnderRetirement = 4,
}

export enum OperationCriticalityLevelEnum {
    VeryLow = 1,
    Low = 2,
    Moderate = 3,
    High = 4,
    VeryHigh = 5,
}

export class SystemModel {
    id: string;
    userFriendlyId: string;
    name: string | undefined;
    description: string | undefined;
    businessAreas: Array<string> = [];
    distributionArea: DistributionArea;
    dataStorageLocations: Array<string> = [];
    supportAccessLocations: Array<string> = [];
    deletionPeriodId: string | null;
    securityMeasures: Array<SecurityMeasureModel> = [];
    responsibleId: string | null = "";
    deletionPeriodReason: string | undefined;
    storageType?: SystemStorageType;
    entityType?: SystemEntityType;
    dataTypes: Array<SystemDataType> = [];
    policies: Array<string> = [];
    status: SystemStatus;
    certifications: Array<string> = [];
    isCriticalForOperation: boolean = false;
    network: string | undefined;
    disableSystemRelations: boolean = false;
    hasSystemRelations: boolean = false;
    suppliers: Array<SystemSupplierViewModel> = [];
    systemPersonalData: SystemPersonalDataViewModel | undefined;
    usesAI: boolean = false;
    companyUsesAIService: boolean = false;
    aiUsageDescription: string | undefined;
    isUseOfAIConsideredHighRisk: boolean = false;
    isDataUsedForTraningOfAIModel: boolean = false;
    operationCriticalityLevel?: OperationCriticalityLevelEnum;
    additionalAccessUsers: Array<string> = [];
    excludedUsers: Array<string> = [];
    visibleToAllUsers: boolean = false;
    allGroupEntityAccess: boolean = true;
    accessBusinessAreas: Array<string> = [];
    groupEntities: Array<string> = [];
    entityTemplateId: string;
    customFieldValues: Array<CustomFieldValue> = [];

    constructor() {
        this.id = "";
        this.entityTemplateId = "";
        this.userFriendlyId = "";
        this.deletionPeriodId = "";
        this.distributionArea = DistributionArea.GlobalSystem;
        this.status = SystemStatus.Active;
    }
}

export interface SystemSupplierViewModel {
    id: string;
    legalEntityId: string | undefined;
    generateSharings: boolean;
    hasDataProcessorAgreement: boolean;
    containsNotAccessibleDocuments: boolean;
    hasTransferImpactAssessment: boolean;
    isSupplierADataProcessor: boolean;
    transferBasisId: string | undefined;
    transferImpactAssessmentId: string | undefined;
    containsNotAccessibleTia: boolean;
    dataProcessorAgreementIds: Array<string>;
    description: string;
    service: string;
    secondarySuppliers: Array<SystemSecondarySupplierViewModel>;
}

export interface SystemSecondarySupplierViewModel {
    id: string;
    dataProcessorId: string | undefined;
    dataStorageLocations: Array<string>;
    hasDataProcessorAgreement: boolean;
    hasTransferImpactAssessment: boolean;
    supportAccessLocations: Array<string>;
    transferBasisId: string | undefined;
    transferImpactAssessmentId: string | undefined;
    containsNotAccessibleTia: boolean;
    isSubDataProcessor: boolean;
    isLink: boolean;
    link: string | undefined;
    note: string | undefined;
}

export interface SystemUpdateModel {
    id: string;
    name: string | undefined;
    description: string | undefined;
    businessAreas: Array<string>;
    distributionArea: DistributionArea;
    dataStorageLocations: Array<string>;
    supportAccessLocations: Array<string>;
    deletionPeriodId: string | null;
    securityMeasures: Array<SecurityMeasureModel>;
    responsibleId: string | null;
    deletionPeriodReason: string | undefined;
    storageType?: SystemStorageType;
    entityType?: SystemEntityType;
    dataTypes: Array<SystemDataType>;
    policies: Array<string>;
    status: SystemStatus;
    certificationIds: Array<string>;
    isCriticalForOperation: boolean;
    network: string | undefined;
    disableSystemRelations: boolean;
    usesAI: boolean;
    companyUsesAIService: boolean;
    aIUsageDescription: string | undefined;
    isUseOfAIConsideredHighRisk: boolean;
    isDataUsedForTraningOfAIModel: boolean;
    operationCriticalityLevel?: OperationCriticalityLevelEnum;
    customFieldValues: Array<CustomFieldValue>;
    visibleToAllUsers: boolean;
    allGroupEntityAccess: boolean;
    accessBusinessAreas: Array<string>;
    additionalAccessUsers: Array<string>;
    excludedUsers: Array<string>;
    groupEntities: Array<string>;
}

export class SystemSubDataProcessorViewModel {
    id: string | undefined;
    dataProcessorId: string | undefined;
    hasDataProcessingAgreement: boolean = false;
    transferBasisId: string | undefined;
    hasTransferImpactAssessment: boolean = false;
    transferImpactAssessmentId: string | undefined;
    dataStorageLocations: Array<string> = [];
    supportAccessLocations: Array<string> = [];
}

export enum SystemTemplateTypesEnum {
    DailyOperation = 1,
    Newsletter = 2,
    PayrollAdministration = 3,
    RecruitmentSolution = 4,
    CRMSystem = 5,
    ERPSystem = 6,
    CloudServices = 7,
    ItSupportAndHosting = 8,
    WebsiteWebshopEtc = 9,
    MarketingServices = 10,
    Whistleblower = 11,
    IPTelephony = 12,
    Surveillance = 13,
    DataStorage = 14,
}
